import { Component } from '@angular/core';

@Component({
  selector: 'app-item-categories',
  templateUrl: './item-categories.component.html',
  styleUrl: './item-categories.component.scss',
})
export class ItemCategoriesComponent {}
